'use strict';

/**
 * Share detail
 *
 * @category   View
 * @module     collection
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoLayoutView = require('base/Colido.LayoutView');
var ShareHeaderView = require('./header');
var ListViewFactory = require('modules/collection/views/partials/list-factory');

var template = require('../../templates/layout/share.hbs');

var ShareLayout = ColidoLayoutView.extend({
    template: template,

    ui: {
        scrollContainer: '.list-layout-scroll-container',
    },

    regions: {
        objectsRegion: '.objects-list-region',
        listHeaderRegion: '.list-header-region',
        detailHeaderRegion: '.detail-header-region',
    },

    getHeaderViewClass: function () {
        return ShareHeaderView;
    },

    onBeforeShow: function(view, region) {
        var viewOptions = {
            model: this.model,
            collection: this.collection,
            shareModel: this.getOption('shareModel'),
        };

        var HeaderViewClass = this.getHeaderViewClass();
        this.listHeaderRegion.show(new HeaderViewClass(_.extend({
            search: false,
            editable: false,
            shareable: false,
            showroomOptions: true,
            viewSwitch: false,
        }, viewOptions)));

        this.detailHeaderRegion.show(new HeaderViewClass(_.extend({
            viewSwitch: false,
            viewSwitchDetail: false,
            backLink: false,
        }, viewOptions)));

        var listViewOptions = _.extend({
            lazyRender: true,
            lazyRenderScrollEl: this.ui.scrollContainer,
            lazyRenderPreviousPageThreshold: 250,
            scrollContainer: this.ui.scrollContainer,
            openChildModel: this.collection.get(this.getOption('activeObject')),
        }, viewOptions);

        if (_.isFunction(this.getEmptyViewClass)) {
            listViewOptions.emptyView = this.getEmptyViewClass();
        }

        var listViewFactory = new ListViewFactory();
        var listView = listViewFactory.createListView('showroom-grid', listViewOptions);

        this.objectsRegion.show(listView);
    },
});

module.exports = ShareLayout;